import actionTypes from "../actions/actionTypes";

const initialState = {
  tokenId: null,
  currentUser: null,
  teacherMessage: null,
  overallPerformanceReport: null,
  loading: false,
  authenticated: false,
  role: null,
  error: null,
  successMessage: null,
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.AUTH_START: {
      return {
        ...state,
        loading: true,
        error: null,
      };
    }
    case actionTypes.AUTH_SUCCESS: {
      return {
        ...state,
        loading: false,
        error: null,
      };
    }
    case actionTypes.AUTH_FAIL: {
      return {
        ...state,
        loading: false,
        error: action.data,
      };
    }
    case actionTypes.CLEAR_AUTH_REDUCER_STATE: {
      return {
        tokenId: null,
        currentUser: null,
        loading: false,
        authenticated: false,
        role: null,
        error: null,
        successMessage: null,
      };
    }
    case actionTypes.IS_AUTHENTICATED: {
      return {
        ...state,
        authenticated: action.value,
        loading: false,
        error: null,
      };
    }
    case actionTypes.GET_ROLE: {
      const newRole = action.role;
      return {
        ...state,
        role: newRole,
      };
    }
    case actionTypes.SET_USER: {
      return {
        ...state,
        currentUser: action.user,
        tokenId: action.tokenId,
      };
    }
    case actionTypes.LOGOUT_START: {
      return {
        ...state,
        loading: true,
      };
    }
    case actionTypes.LOGOUT_SUCCESS: {
      return {
        ...state,
        loading: false,
        successMessage: action.data,
      };
    }
    case actionTypes.LOGOUT_FAIL: {
      return {
        ...state,
        loading: false,
        error: action.data,
      };
    }
    case actionTypes.SIGN_OUT: {
      return {
        ...state,
        tokenId: null,
        currentUser: null,
        authenticated: false,
        role: null,
        error: null,
      };
    }
    case actionTypes.CLEAR_AUTH_ERROR: {
      return {
        ...state,
        error: null,
      };
    }
    case actionTypes.CLEAR_AUTH_SUCCESS: {
      return {
        ...state,
        successMessage: null,
      };
    }
    case actionTypes.SET_TEACHER_MESSAGE: {
      return {
        ...state,
        teacherMessage: action.data,
      };
    }
    case actionTypes.OVERALL_PERFORMANCE: {
      return {
        ...state,
        overallPerformanceReport: action.data,
      };
    }
    default:
      return state;
  }
};

export default reducer;
